<template>
  <div class="wlx-apply-table-wrapper">
    <div class="basic-head-main" :style="{backgroundImage:'url('+headBg+')'}">
      <div class="basic-head-con">
        <div class="head-title-con clearfix">
          <div class="fl basic-book-img-con">
            <img src="~assets/images/basic-book-img.png" alt>
          </div>
          <div class="fr head-title-word">
            <!-- <p class="p-title-1">“1+X”物流管理职业技能等级</p> -->
            <p class="p-title-1">{{tableTitle}}申请表</p>
            <p class="p-title-2 p-title-2-1">——北京中物联物流采购培训中心</p>
          </div>
        </div>
      </div>
    </div>
    <div class="apply-table-content">
      <table border="0" cellspacing="0" cellpadding="0">
        <tr>
          <td class="u-label-title">姓名</td>
          <td colspan="2">
            <el-input v-model="tableDetail.Name" disabled></el-input>
          </td>
          <td class="u-label-title">性别</td>
          <td colspan="2">
            <el-input v-model="tableDetail.Sex" disabled></el-input>
          </td>
          <td colspan="2" class="u-label-title">出生年月</td>
          <td colspan="2">
               <el-input v-model="tableDetail.Birth" disabled></el-input>
            <!-- <el-date-picker
              value-format="yyyy-MM-dd"
              v-model="tableDetail.Birth"
              type="date"
              placeholder="请选择日期"
              disabled
            ></el-date-picker> -->
          </td>
          <td colspan="3" rowspan="4" width="160px">
            <img :src="tableDetail.Photo" alt="" class="apply-user-avatar">
          </td>
        </tr>
        <tr>
          <td class="u-label-title">民族</td>
          <td colspan="2">
            <el-input v-model="tableDetail.Nation" disabled></el-input>
          </td>
          <td class="u-label-title">政治面貌</td>
          <td colspan="2">
            <el-input v-model="tableDetail.PoliticalFace" disabled></el-input>
          </td>
          <td colspan="2" class="u-label-title">健康状况</td>
          <td colspan="2">
            <el-input v-model="tableDetail.Health" disabled></el-input>
          </td>
        </tr>
        <tr>
          <td rowspan="2" class="u-label-title">学历</td>
          <td rowspan="2" colspan="2">
            <el-input v-model="tableDetail.Education" class="input-edu" disabled></el-input>
          </td>
          <td class="u-label-title">从事职业</td>
          <td colspan="2">
            <el-input v-model="tableDetail.Occupation" disabled></el-input>
          </td>
          <td colspan="2" class="u-label-title">技术职称</td>
          <td colspan="2">
            <el-input v-model="tableDetail.TechnicalTitle" disabled></el-input>
          </td>
        </tr>
        <tr>
          <td class="u-label-title">年限</td>
          <td colspan="2">
            <el-input v-model="tableDetail.Years" disabled></el-input>
          </td>
          <td colspan="2" class="u-label-title">职业技能证书</td>
          <td colspan="2">
            <el-input v-model="tableDetail.Certificate" disabled></el-input>
          </td>
        </tr>
        <tr>
          <td colspan="3" class="u-label-title">工作单位</td>
          <td colspan="3">
            <el-input v-model="tableDetail.WorkUnit" disabled></el-input>
          </td>
          <td colspan="2" class="u-label-title">身份证号</td>
          <td colspan="5">
            <el-input v-model="tableDetail.CardNumber" disabled></el-input>
          </td>
        </tr>
        <tr>
          <td colspan="3" class="u-label-title">通信地址</td>
          <td colspan="10">
            <el-input v-model="tableDetail.MailAddress" disabled></el-input>
          </td>
        </tr>
        <tr>
          <td colspan="3" class="u-label-title">现居住地</td>
          <td colspan="10">
            <!-- <el-input v-model="linkAdderss"></el-input> -->
            <div class="td-select-city">
              <span>省份:</span>
              <el-select v-model="tableDetail.Province" clearable placeholder="省份" disabled>
                <el-option
                  v-for="item in provinceList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="td-select-city">
              <span>城市:</span>
              <!-- <el-input v-model="tableDetail.cityPid" disabled></el-input> -->
              <el-select v-model="tableDetail.City" clearable placeholder="城市" disabled>
                <el-option
                  v-for="item in cityList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="td-select-city">
              <span>县/区:</span>
              <!-- <el-input v-model="tableDetail.areaPid" disabled></el-input> -->
              <el-select v-model="tableDetail.Area" clearable placeholder="县/区" disabled>
                <el-option
                  v-for="item in areaList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="3" class="u-label-title">邮编</td>
          <td colspan="3">
            <el-input v-model="tableDetail.ZipCode" disabled></el-input>
          </td>
          <td colspan="2" class="u-label-title">联系电话/手机号</td>
          <td colspan="5">
            <el-input v-model="tableDetail.Phone" disabled></el-input>
          </td>
        </tr>
        <tr>
          <td colspan="3" class="u-label-title">专业擅长领域</td>
          <td colspan="10">
            <el-input type="textarea" :rows="8" v-model="tableDetail.ExpertField" disabled></el-input>
          </td>
        </tr>
        <tr>
          <td colspan="3">
            <div class="label-job-con u-label-title">
              工作简历
              担任年度、职务
              <span>
                【 职称证明、
                专家证书丶
                职业技能证书丶
                大赛评委证书丶
                职称证书等】
              </span>
            </div>
          </td>
          <td colspan="10">
            <el-input type="textarea" :rows="8" v-model="tableDetail.Resume" disabled></el-input>
          </td>
        </tr>
        <tr>
          <td colspan="3">
            <div class="label-job-con u-label-title">
              熟悉何种业务与
              技术、荣誉、业绩、成果和著作等。
            </div>
          </td>
          <td colspan="10">
            <el-input type="textarea" :rows="6" v-model="tableDetail.Achievements" disabled></el-input>
          </td>
        </tr>

        <tr>
          <td colspan="3" class="u-label-title">
            <div class="label-job-con">外语及其熟悉程度</div>
          </td>
          <td colspan="10">
            <el-input type="textarea" :rows="3" v-model="tableDetail.ForeignLange" disabled></el-input>
          </td>
        </tr>
        <tr>
          <td colspan="13">
            <div class="label-opinion-title u-label-title">推荐单位意见：</div>
            <div>
              <el-input type="textarea" :rows="8" v-model="tableDetail.UnitOpinion" disabled></el-input>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="13">
            <div class="label-opinion-title u-label-title">
              <span>北京中物联物流采购培训中心</span> 审核意见：
            </div>
            <div>
              <el-input type="textarea" :rows="8" v-model="tableDetail.AuditOpinion" disabled></el-input>
            </div>
          </td>
        </tr>
        <!-- <tr>
          <td rowspan="8">
            <div class="label-job-con">专家证书情况</div>
          </td>
          <td colspan="2">证书编号</td>
          <td colspan="10" rowspan="3">
            <ul class="clearfix expert-certify-ul">
              <li
                v-for="(item,index) in expertCertify"
                :key="index"
                class="fl expert-certify-li"
                :class="{fistCertify : index == 0}"
              >
                <div class="certify-li-cell certify-li-cell-num">
                  <el-input v-model="item.certifyNum"></el-input>
                </div>
                <div class="certify-li-cell">
                  <el-date-picker
                    value-format="yyyy-MM-dd"
                    v-model="item.certifyDate"
                    type="date"
                    placeholder="请选择日期"
                  ></el-date-picker>
                </div>
                <div class="certify-li-cell">
                  <el-input v-model="item.cerfityName"></el-input>
                </div>
              </li>
            </ul>
          </td>
        </tr>
        <tr>
          <td colspan="2">颁证日期</td>
        </tr>
        <tr>
          <td colspan="2">证书名称</td>
        </tr>
        <tr>
          <td colspan="12">
            <el-input type="textarea" :rows="8" v-model="certifySituation"></el-input>
          </td>
        </tr>-->
      </table>
      <div class="submit-apply-btn">
        <el-button type="primary" @click="goBank">返回</el-button>
        <el-button type="primary" @click="deleteApplyTable" >删除</el-button>
      </div>

    </div>
  </div>
     
</template>

<script>
import avatarUpload from "components/avatarUpload.vue";

export default {
  data() {
    return {
      provinceList:[],   //省
      cityList:[],       //市
      areaList:[],       //区
      tableTitle: "",
      isSubmit: false,
      jobContent: "",
      name: "",
      sex: "",
      bornDate: "",
      nation: "",
      polityOutlook: "",
      healthy: "",
      education: "",
      business: "",
      majorField: "",
      jobPost: "",
      jobYear: "",
      skillCertify: "",
      jobPlace: "",
      IDNum: "",
      linkAdderss: "",
      provincePid:'',    //省
      cityPid:'',
      areaPid:'',
      postCode: "",
      phoneNum: "",
      jobResume: "",
      selfSpeciality: "",
      foreignLanguages: "",
      unitOpinion: "",
      evaluateOpinion: "",
      certifySituation: "",
      expertCertify: [
        {
          certifyNum: "",
          certifyDate: "",
          cerfityName: ""
        },
        {
          certifyNum: "",
          certifyDate: "",
          cerfityName: ""
        },
        {
          certifyNum: "",
          certifyDate: "",
          cerfityName: ""
        },
        {
          certifyNum: "",
          certifyDate: "",
          cerfityName: ""
        }
      ],
      urlAliyunOSS: "/api/design/osssign/getsign",
      avatar: "",
      headBg: require("assets/images/wlx-baic-bg-img.png"),
      tableDetail:{}
    };
  },
  props: {
    userType: {
      type: String,
      default: ""
    },
    userId: {
      type: String,
      default: ""
    }
  },
  components: {
    avatarUpload
  },
  created() {
    if (this.userType == "1") {
      this.tableTitle = "讲师";
    }
    if (this.userType == "2") {
      this.tableTitle = "考评员";
    }
    this.submitApply();
  },
  methods: {
    goBank(){
      this.$router.go(-1);
    },
    submitApply() {
      this.$http
        .post("/api/XOrg/AssociationTeacher/getTrainApplyInfo", {
          id: this.userId
        })
        .then(res => {
           if(res.code > 0){
             this.tableDetail = res.info;
           }
        });
    },

    deleteApplyTable(){
      var that = this;
      this.$confirm("此操作将删除该申报信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$http
            .post("/api/XOrg/AssociationTeacher/deleteApplyTable", {
              id: that.userId
            })
            .then(rst => {
              if (rst.code > 0) {
                that.$message({
                  type: "success",
                  message: "删除成功!"
                });
                that.$router.go(-1);
              } else {
                that.$message.error("删除失败!");
              }
            });
        }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  }
};
</script>

<style lang="scss">
.wlx-apply-table-wrapper {
  height: 100%;
  overflow: auto;
  background: #f0f6ff;
  .basic-head-main {
    height: 706px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center top;
    .basic-head-con {
      margin: 0 auto;
      width: 1000px;
    }
    .head-logo-con {
      padding: 26px 0 0 26px;
    }
    .logo-img-val {
      height: 40px;
    }
    .head-title-con {
      position: relative;
      padding-top: 40px;
    }
    .basic-book-img-con {
      margin-left: 10px;
    }
    .head-title-word {
      position: absolute;
      right: 0;
      top: 80px;
      z-index: 100;
      color: #fff;
    }
    .p-title-1 {
      font-size: 55px;
      font-weight: bold;
      text-align: center;
    }
    .p-title-2-1 {
      margin-top: 50px;
      text-align: right;
      font-size: 20px;
    }
  }
  .apply-table-content {
    margin: -325px auto 0;
    padding: 20px 0;
    padding-top: 50px;
    width: 1000px;
    background: #fff;
    .el-input.is-disabled .el-input__inner{
       color:#666;
    }
     .el-textarea.is-disabled .el-textarea__inner{
       color:#666;
    }
    .apply-user-avatar{
        display: block;
        margin: 0 auto;
        width: 148px;
        height: 148px;
        border-radius: 5px;
    }
  }
  .apply-table-title {
    padding: 20px 0;
    text-align: center;
  }
  .submit-apply-btn {
    padding: 30px 0;
    text-align: center;
  }
  .label-job-con {
    padding: 0 20px;
  }
  table {
    margin: 0 auto;
    width: 960px;
    border-right: 1px solid #999;
    border-bottom: 1px solid #999;
    table-layout: fixed;
    word-break: break-all;
    background: #f0f0f0;
  }
  .u-label-title {
    font-weight: bold;
  }
  .demo-table {
    margin-top: 100px;
  }
  .expert-certify-ul {
    height: 100%;
  }
  .expert-certify-li {
    width: 25%;
  }
  .certify-li-cell {
    border-left: 1px solid #999;
    border-top: 1px solid #999;
  }
  .certify-li-cell-num {
    border-top: none;
  }
  .fistCertify {
    .certify-li-cell {
      border-left: none;
    }
  }
  .el-textarea__inner,
  .el-input__inner {
    border: none;
    font-size: 16px;
    color: #000;
  }
  .input-edu .el-input__inner {
    height: 82px;
    line-height: 82px;
  }
  .el-textarea__inner:focus {
    border: none;
  }
  .el-input__inner:focus {
    border: none;
  }
  .el-date-editor.el-input {
    width: 100%;
  }
  table td {
    border-left: 1px solid #999;
    border-top: 1px solid #999;
    text-align: center;
  }
  .label-opinion-title {
    padding: 10px;
    text-align: left;
  }
  .sp-mark-label {
    color: red;
  }
  .h4-major-title {
    padding: 10px 0;
  }
  td {
    height: 40px;
    // width: 76.9px;
    font-size: 16px;
  }
  .td-select-city{
    width: 33.333%;
    display: inline-block;
    .el-select{
      width: 75%;
    }
  }
}
</style>
